<template>
  <div id="fof-error">
    <error-component>
      <template slot="title">
        <h1>404 Error</h1>
      </template>
      <template slot="subtitle">
        <h2>Page not found</h2>
      </template>
      <template slot="message">
        <p>
          Missing a Partnership? Add a new Partnership by following the link below.
        </p>
      </template>
    </error-component>
  </div>
</template>

<script>
import ErrorComponent from '@/components/ErrorComponent'

export default {
  name: 'FOFError',
  components: {
    ErrorComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FOFError.vue